module.exports = __webpack_public_path__ + "media/old_images/image-promo-landing-06-c715b87c.jpg";